import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import Dashboard from "./Pages/Dashboard/Dashboard";
import DecisionMaker from "./Pages/AiDecisionMakers/Index";
import AILeads from "./Pages/AiLeads/Index";
import AiProfile from "./Pages/AiProfile/Index";
import ProfileFormTable from "./Pages/AiProfile/ProfileFormTable/Index";
import ProspectProfile from "./Pages/AiProfile/AiProspectProfile/Index";
import CompanyProfileScreen from "./Pages/AiLeads/CompanyProfileScreen/Index";
import { ToastContainer } from "react-toastify";
import {
  AI_DECISION_MAKER,
  AI_LEADS,
  AI_PATH,
  AI_PROFILE,
  AI_PROFILE_FORM_TABLE,
  AI_PROSPECT_PROFILE,
  COMING_SOON,
  COMPANY_PROFILE_SCREEN,
  DASHBOARD,
  PDF_SAMPLE,
  ARCHIVED,
  FAVORITES,
  DATA_ENRICH,
  TRACKING,
  PROFILE,
  ERROR_SCREEN,
  MAINTENANCE,
  FAVORITES_LIST,
  PROSPECT_SEARCH_RESULTS,
  ORGANIZATION_SEARCH_RESULTS,
  ORBIT_INTEL_CHAT,
} from "./Utils/Constants";
import Comingsoon from "./Components/ComingSoon/ComingSoon";
import PDFSample from "./Components/AiLeads/CompanyProfile/PDF/Index";
import CombinedPDFComponent from "./Pages/AiLeads/PDFDATA/CombinedData";
import Archived from "./Pages/ArchivedRecords/Archived";
import Favorites from "./Pages/Favorites/Favorites";
import DataEnrich from "./Pages/DataEnrich/DataEnrich";
import Tracking from "./Pages/Tracking/Tracking";
import Profile from "./Pages/ProspectProfile/Profile";
import AIPath from "./Pages/AiPath/AiPathFilters/Index";
import Maintenance from "./Pages/ErrorAndMaintenance/Maintenance";
import ErrorScreen from "./Pages/ErrorAndMaintenance/ErrorScreen";
import FavoritesList from "./Pages/FavoriteList/FavoritesList";
import ProspectSearchResults from "./Components/Header/PeopleSearch/ProspectSearchResults";
import OrganizationSearchResults from "./Components/Header/OrganizationSearch/OrganizationSearchResults";
import OrbitIntelChatPage from "./Pages/OrbitIntelChatPage/OrbitIntelChatPage";

function App() {
  return (
    <div className="App">
      <Router>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <Routes>
          <Route path="/" element={<Navigate to={DASHBOARD} replace />} />
          <Route path={DASHBOARD} element={<Dashboard />} />
          <Route path={AI_LEADS} element={<AILeads />} />
          <Route path={AI_DECISION_MAKER} element={<DecisionMaker />} />
          <Route path={AI_PATH} element={<AIPath />} />
          <Route path={AI_PROFILE} element={<AiProfile />} />
          <Route path={AI_PROFILE_FORM_TABLE} element={<ProfileFormTable />} />
          <Route path={AI_PROSPECT_PROFILE} element={<ProspectProfile />} />
          <Route path={COMPANY_PROFILE_SCREEN} element={<CompanyProfileScreen />} />
          <Route path={ARCHIVED} element={<Archived />} />
          <Route path={FAVORITES} element={<Favorites />} />
          <Route path={FAVORITES_LIST} element={<FavoritesList />} />
          <Route path={DATA_ENRICH} element={<DataEnrich />} />
          <Route path={TRACKING} element={<Tracking />} />
          <Route path={PROFILE} element={<Profile />} />
          <Route path={ORBIT_INTEL_CHAT} element={<OrbitIntelChatPage />} />
          <Route path={PROSPECT_SEARCH_RESULTS} element={<ProspectSearchResults />} />
          <Route path={ORGANIZATION_SEARCH_RESULTS} element={<OrganizationSearchResults />} />
          <Route path={COMING_SOON} element={<Comingsoon />} />
          <Route path={PDF_SAMPLE} element={<PDFSample />} />
          <Route path={"/combinedData"} element={<CombinedPDFComponent />} />
          <Route path="*" element={<ErrorScreen />} />
          <Route path={MAINTENANCE} element={<Maintenance />} />
        </Routes>
      </Router>
    </div>
  );
}
export default App;
